define([
        "language/resource",
        "authui/iamUtils",
        "base/js/closecookie/controllers/closecookieController"
    ], function (i18n, iamUtils,CloseCookie) {
        "use strict";

        var ctrl = function ($scope) {

            CloseCookie.call(this, $scope, i18n, iamUtils);

        };

        ctrl = ["$scope", ctrl];
        var loginModule = angular.module('authui.config');
        loginModule.controller('authui.closecookie.ctrl', ctrl);
        return ctrl;
    }
);


// WEBPACK FOOTER //
// ./public/hws/js/closecookie/controllers/closecookieController.js